import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Link from '@mui/material/Link';

import { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { categoryList, categoryDelete } from "../../../actions/category";

import { useNavigate } from 'react-router-dom';

export default function CategoryList() {

    const category = useSelector(state => state.category);
    console.log("category : ", category);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleWriteCategory = (event) => {
      navigate("/dashboard/categoryWrite");
    };

    const handleDeleteCategory = (event, idx) => {
      console.log(idx);

      if (window.confirm("정말 삭제하시겠습니까??") === true)   //확인
      {
        // 여기서 디스패치로~
        dispatch(categoryDelete(idx))
        .then(data => 
        {
            console.log("data : ", data);
        })
        .catch(e => {
            console.log(e);
        });

        navigate("/dashboard/categoryList");  
      }
      else  //취소
      {
        return false;
      }

    };

    useEffect(() => {

        // 여기서 디스패치로~
        dispatch(categoryList())
        .then(data => 
        {
            console.log("data : ", data);
        })
        .catch(e => {
            console.log(e);
        });
        
        return () => {      // 언마운트
            console.log("언마운트!");
        };

    }, [dispatch])

  return (
    <Card sx={{ minWidth: 275 }}>
      <CardContent>
      카테고리 리스트
      <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="center">번호</TableCell>
            <TableCell align="center">카테고리 이름</TableCell>
            <TableCell align="center">카테고리 설명</TableCell>
            <TableCell align="center">등록자</TableCell>
            <TableCell align="center">수정</TableCell>
            <TableCell align="center">삭제</TableCell>
            <TableCell align="center">등록일</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {category && category.map((row, index) => (
            <TableRow
              key={index}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row" align="center">
                {row.category_idx}
              </TableCell>
              <TableCell align="center"><Link href={`/dashboard/CategoryView/${row.category_idx}`} underline="none">{row.category_name}</Link></TableCell>
              <TableCell align="left">{row.category_desc}</TableCell>
              <TableCell align="center">{row.reg_id}</TableCell>
              <TableCell align="right"><Link href={`/dashboard/CategoryModify/${row.category_idx}`} underline="none">수정</Link></TableCell>
              <TableCell align="right"><Link onClick={(e)=>handleDeleteCategory(e, row.category_idx)} value={row.category_idx} underline="none">삭제</Link></TableCell>
              <TableCell align="center">{row.reg_date}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      </TableContainer>

      </CardContent>
      <CardActions>
        <Button onClick={handleWriteCategory} size="small">카테고리 추가</Button>
      </CardActions>
    </Card>
  );
}